<div class = "ui-health-analysis-timeline-container">
    <div class = "ui-health-analysis-timeline-instant-container" *ngFor = "let instant of timeline; let i = index">
        <div class = "ui-health-analysis-timeline-instant-side" >
            <div class = "ui-health-analysis-timeline-instant-step-icon ui-panel-primary-active">
                @if (!['GRANTED', 'DOWNLOADED'].includes(instant.type)) {
                    <i [class] = "(journeySteps[instant.step].icon)"></i>
                } @else {
                    <i [class] = "(instant.type === 'GRANTED') ? 'uii-square-share' : 'uii-download'"></i>
                }
            </div>
            <div class = "ui-divisor-vertical" *ngIf = "i !== timeline.length - 1"></div>
        </div>
        <div class = "ui-health-analysis-timeline-instant">
            <div class = "ui-health-analysis-timeline-instant-header">
                <div class = "ui-health-analysis-timeline-instant-step">
                    @if (!['GRANTED', 'DOWNLOADED'].includes(instant.type)) {
                        <span class = "ui-health-analysis-timeline-instant-step-name ui-panel-bordered ui-panel-primary-active">
                            {{ instant.step | HealthAnalysisStep }}
                        </span>
                    } @else {
                        <span class = "ui-health-analysis-timeline-instant-step-name ui-panel-bordered ui-panel-primary-active">
                            {{ (instant.type === 'GRANTED') ? 'Liberado' : 'Arquivo Baixado' }}
                        </span>
                    }
                </div>
                <div class = "ui-health-analysis-timeline-instant-step-date">
                    <i class = "uii-clock"></i>
                    <span>{{ instant.createdAt | date: 'd \'de\' MMMM \'de\' y'}}</span>
                </div>
            </div>
            <div class = "ui-health-analysis-timeline-instant-body">
                <div class = "ui-health-analysis-timeline-instant-body-important">
                    @if (instant.metadata) {
                        @if (!['GRANTED', 'DOWNLOADED', 'VIEWED'].includes(instant.type)) {
                            @if (instant.metadata.old && instant.metadata.new.step === instant.metadata.old.step) {
                                @if (instant.metadata.new.detail && instant.metadata.old.detail && instant.metadata.new.detail.workflowInstanceId !== instant.metadata.old.detail.workflowInstanceId) {
                                    <span>
                                        O Workflow será executado novamente <b>{{ instant.step | HealthAnalysisStep }}</b>
                                    </span>
                                } @else {
                                    <span>
                                         As informações foram alteradas
                                    </span>
                                }
                            } @else if (instant.metadata.old && instant.metadata.new.step !== instant.metadata.old.step) {
                                @if (instant.type === 'REPROCESSED') {
                                    <span>
                                        A amostra será reprocessada. Voltando da etapa <b>{{ instant.metadata.old.step | HealthAnalysisStep }}</b> para <b>{{ instant.metadata.new.step | HealthAnalysisStep }}</b>
                                    </span>
                                } @else {
                                    <span>
                                        A Etapa foi alterada de <b>{{ instant.metadata.old.step | HealthAnalysisStep }}</b> para <b>{{ instant.metadata.new.step | HealthAnalysisStep }}</b>
                                    </span>
                                }
                            } @else if (instant.metadata.old) {
                                <span>
                                    A amostra foi criada!
                                </span>
                            }
                        } @else {
                            @if (instant.type === 'GRANTED') {
                                <span>
                                    O exame foi liberado ao {{ instant.metadata.new.releasedToPatientAt ? 'paciente ' : 'prescritor' }}
                                </span>
                            } @else if (instant.type === 'DOWNLOADED') {
                                <span>
                                    O arquivo <b>{{ instant.metadata['downloadedFile'] }}</b> foi baixado.
                                </span>
                            } @else {
                                <span>
                                    O prescritor acessou o resultado.
                                </span>
                            }
                        }
                    } @else {
                        <span>
                            Nenhuma alteração identificada
                        </span>
                    }
                </div>
                @if (instant.metadata) {
                    <button class = "ui-button ui-text-button" (click) = "eventExpandEvent(instant._id)">
                        <i class = "ui-icon uii-eye"></i>
                        <span>Ver todos os atributos</span>
                        <i [ngClass] = "{
                        'uii-chevron-down': !expandedEvent.has(instant._id),
                        'uii-chevron-up': expandedEvent.has(instant._id)
                    }"></i>
                    </button>
                    <div class = "ui-health-analysis-timeline-instant-detail-container" *ngIf = "expandedEvent.has(instant._id)">
                    <div class = "ui-title">
                        <i class = "uii-eye"></i><span></span>
                        <span style = "margin-left: 0.5rem"> Detalhes das Modificações</span>
                    </div>
                    <div class = "ui-sub-title" *ngIf = "instant.metadata.old">
                        <span>Estado anterior</span>
                    </div>
                    <div class = "ui-health-analysis-timeline-instant-detail" *ngIf = "instant.metadata.old">
                        <div class = "ui-health-analysis-timeline-instant-detail-field" *ngFor = "let element of getElementFields(instant.metadata.old)">
                            <span class = "ui-health-analysis-timeline-instant-detail-field-name">{{ element.key }}</span>
                            <span class = "ui-health-analysis-timeline-instant-detail-field-value">{{ element.value }}</span>
                        </div>
                    </div>
                    <div class = "ui-sub-title" *ngIf = "instant.metadata.new">
                        <span>Estado atual</span>
                    </div>
                    <div class = "ui-health-analysis-timeline-instant-detail" *ngIf = "instant.metadata.new">
                        <div class = "ui-health-analysis-timeline-instant-detail-field" *ngFor = "let element of getElementFields(instant.metadata.new)">
                            <span class = "ui-health-analysis-timeline-instant-detail-field-name">{{ element.key }}</span>
                            <span class = "ui-health-analysis-timeline-instant-detail-field-value">{{ element.value }}</span>
                        </div>
                    </div>
                    <div class = "ui-sub-title">
                        <span>Informações do Evento</span>
                    </div>
                    <div class = "ui-health-analysis-timeline-instant-detail">
                        <div class = "ui-health-analysis-timeline-instant-detail-field">
                            <span class = "ui-health-analysis-timeline-instant-detail-field-name">Identificador do Evento</span>
                            <span class = "ui-health-analysis-timeline-instant-detail-field-value">{{ instant._id }}</span>
                        </div>
                        <div class = "ui-health-analysis-timeline-instant-detail-field" *ngIf = "instant.createdAt">
                            <span class = "ui-health-analysis-timeline-instant-detail-field-name">Criado em</span>
                            <span class = "ui-health-analysis-timeline-instant-detail-field-value">{{ instant.createdAt | date: 'short' }}</span>
                        </div>
                        <div class = "ui-health-analysis-timeline-instant-detail-field">
                            <span class = "ui-health-analysis-timeline-instant-detail-field-name">Identificador da Amostra</span>
                            <span class = "ui-health-analysis-timeline-instant-detail-field-value">{{ instant.healthAnalysisId }}</span>
                        </div>
                    </div>
                </div>
                }
            </div>
            <div class = "ui-divisor"></div>
            <div class = "ui-health-analysis-timeline-instant-footer">
                <div class = "ui-health-analysis-timeline-instant-user">
                    <div class  = "ui-user-photo ui-health-analysis-timeline-instant-user-photo">
                        {{ instant.createdByUser.name.at(0) }}{{instant.createdByUser.name.split(' ').pop()?.at(0)}}
                    </div>
                    <div class = "ui-health-analysis-timeline-instant-user-detail">
                        <div class = "ui-title">
                            {{ instant.createdByUser?.name }}
                        </div>
                        <div class = "ui-sub-title">
                            {{ instant.createdByUser?.email }}
                        </div>
                    </div>
                </div>
                @if (!['GRANTED', 'DOWNLOADED'].includes(instant.type)) {
                    <div class = "ui-health-analysis-timeline-instant-event">
                        {{ i === timeline.length - 1 ? 'Criado por' : 'Modificado por' }}
                    </div>
                } @else {
                    <div class = "ui-health-analysis-timeline-instant-event">
                        {{ instant.type === 'GRANTED' ? 'Liberado por' : 'Baixado por' }}
                    </div>
                }
            </div>
        </div>
    </div>
</div>
